module.exports = __webpack_public_path__ + "media/turn-left.f463d700.mp3";